import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-menubar-list"
}
const _hoisted_2 = {
  key: 0,
  class: "p-menubar-list"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "image" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "lead text-muted" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Email:", -1)
const _hoisted_9 = {
  key: 1,
  class: "p-menubar-list"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Login")

import { ref, inject } from 'vue';
import { useAuth0 } from '@auth0/auth0-vue';
import { useRouter } from 'vue-router';
import MyProfile from './MyProfile.vue';
import { useStore } from 'vuex';
import { MutationTypes } from "../store/mutations";


export default /*#__PURE__*/_defineComponent({
  name: 'CustomMenubar',
  props: ['model', 'user'],
  setup(__props) {

const props = __props

const posthog = inject("posthog");
const auth0 = useAuth0();
const router = useRouter();

const visible = ref(false);
const store = useStore();
const role = ref('');

/**
 * Logout using auth0
 */
const logout = () => {
    // reset the value for initial login
    store.commit(MutationTypes.SET_INITIALLOGIN, false);
    const email = auth0.user.value.email;
    posthog.capture("logout_button_clicked", { email: email });
    /**
     * Important because relogin of different credentials is just loading the old session
     */
    sessionStorage.removeItem('vuex');
    localStorage.clear();
    auth0.logout({
        returnTo: window.location.origin
    });
}

/**
 * Login using auth0
 */
const login = () => {
    auth0.loginWithRedirect();
}

/**
 * This is for us to handle the redirection from home page to auth0 login page
 * once the user clicks login, to and from will have the same value 'home'
 */
router.afterEach(async (to, from) => {
    if (to.name === 'storedisable') {
      return;
    }

    if (auth0.isAuthenticated.value && (to.name === 'home' && from.name === 'home') && store.state.initialLogin === false) {
        posthog.init(process.env.VUE_APP_POSTHOG_TOKEN, { api_host: process.env.VUE_APP_POSTHOG_API_URL, enable_recording_console_log: true })
        // set true value for initial login for us to send a Posthog request once only
        store.commit(MutationTypes.SET_INITIALLOGIN, true);
        // fetch user profile to get email
        const { email, name, sub }  = { ...auth0.user.value };
        role.value = auth0.user.value['http://protractor.com/role'];
        const storeid = auth0.user.value['http://protractor.com/storeid'];
        // send a PostHog request after successful authentication
        const id = sub.split('|')[1]; // auth0|qwer123tyuio456 will return qwer123tyuio456
        posthog.capture("login_button_clicked", { email: email });
        posthog.identify(id, { email: email, name: name, role: role, storeid: storeid });
    }
});

/**
 * Navigate to different pages
 * @param event 
 * @param path 
 */
const navigateTo = (event, label: string, path: string) => {
    // special case, only for store home page as enterprise admin
    if (label === 'Enterprise Home' && store.state.isStoreLogin) {
        return store.commit(MutationTypes.SET_ISSTORELOGIN, false);
    }
    event.preventDefault();
    router.push(path);
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Menubar = _resolveComponent("Menubar")!

  return (_openBlock(), _createBlock(_component_Menubar, null, {
    start: _withCtx(() => [
      (props.user)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.model, (item) => {
              return (_openBlock(), _createBlock(_component_Button, {
                class: "p-menubar-item",
                onClick: (event) => navigateTo(event, item.label, item.path),
                key: item.index
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    end: _withCtx(() => [
      (props.user)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createElementVNode("img", {
              src: props.user?.picture,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = true)),
              alt: "User's profile picture",
              class: "border-circle img-fluid profile-picture"
            }, null, 8, _hoisted_3),
            _createVNode(_component_Dialog, {
              class: "profile",
              visible: visible.value,
              "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
              modal: "",
              header: "Profile"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: props.user?.picture,
                    alt: "User's profile picture",
                    class: "border-circle img-fluid profile-picture"
                  }, null, 8, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h2", null, _toDisplayString(props.user?.name), 1),
                  _createElementVNode("p", _hoisted_7, [
                    _hoisted_8,
                    _createTextVNode(" " + _toDisplayString(props.user?.email), 1)
                  ]),
                  _createVNode(MyProfile),
                  _createVNode(_component_Button, {
                    label: "Log Out",
                    class: "logout",
                    onClick: logout
                  })
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_9, [
            _createVNode(_component_Button, {
              class: "p-menubar-item",
              onClick: login
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }))
}
}

})